export const linkConfig = {
  glossary: "/help",
  rule: "/help/rule",
  privacy: "/help/privacy",
  terms: "/help/terms",
}
